import { zoneI } from "../hooks/UbicationFilterContext";

export const getUbication = (
  ubicationList: zoneI[],
  zoneId?: string | null
) => {
  if (!zoneId) return ubicationList[0];
  let hotel: zoneI | undefined = undefined;
  let ubication = ubicationList.find((ubication) => {
    if (ubication.hotelDataList) {
      const newHotel = ubication.hotelDataList.find(
        (hotel) => hotel.id === zoneId
      );
      if (newHotel) {
        hotel = newHotel;
        return newHotel;
      }
    }
    return ubication.id === zoneId;
  });
  if (hotel) return hotel;
  if (ubication) return ubication;
  return ubicationList[0];
};
